import { stateRef } from '../../framework/store'
import { TSG_ID_NONE } from '../../framework/constants'

export const isNoneTsg = () => {
  const tsgId = stateRef.current.auth?.tsg_id
  return tsgId === TSG_ID_NONE
}

export const globalAvail = () => {
  const tsgId = stateRef.current.auth?.tsg_id
  return !tsgId || tsgId !== TSG_ID_NONE
}

export const noTsgAccess = () => Boolean(stateRef.current.auth?.access?.noRoleAccess)
export const isIPRestricted = () => Boolean(stateRef.current.auth?.instances?.error?.ipRestricted)
export const tsgAccessAvail = () => !noTsgAccess() && !isIPRestricted()

export const globalAndTsgAvail = () => globalAvail() && !noTsgAccess()
